"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFloat = exports.Value = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _types = require("../types/");
var _jsxRuntime = require("react/jsx-runtime");
var isFloat = exports.isFloat = function isFloat(n) {
  return Number(n) === n && n % 1 !== 0 || isNaN(n);
};
var Value = exports.Value = function Value(props) {
  var value = props.value,
    keyName = props.keyName,
    keys = props.keys;
  var reset = {
    keyName: keyName,
    keys: keys
  };
  if (value instanceof URL) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeUrl, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  if (typeof value === 'string') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeString, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  if (value === true) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeTrue, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  if (value === false) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeFalse, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  if (value === null) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeNull, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  if (value === undefined) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeUndefined, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  if (value instanceof Date) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeDate, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  if (typeof value === 'number' && isNaN(value)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeNan, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  } else if (typeof value === 'number' && isFloat(value)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeFloat, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  } else if (typeof value === 'bigint') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeBigint, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  } else if (typeof value === 'number') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_types.TypeInt, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      children: value
    }));
  }
  return null;
};
Value.displayName = 'JVR.Value';